/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnvironmentId } from "../../commons/types/EnvironmentId";
import { KeyAdoptionStrategy } from "./KeyAdoptionStrategy";
export const FamilyConfig = core.serialization.object({
    environmentId: EnvironmentId,
    namespace: core.serialization.string().optional(),
    name: core.serialization.string(),
    sourceKeys: core.serialization.list(core.serialization.string()),
    adoptionStrategy: KeyAdoptionStrategy,
});
